// components
import { styled, useTheme } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

// other
import { usePersona } from '../../../../../components/hooks/usePersona';
import { useAgencyShell } from '../../../../../personas/broker/useAgencyShell';

export function LinkedLogo() {
  const { personaHome } = usePersona();

  return (
    <Link to={personaHome}>
      <LogoImage />
    </Link>
  );
}

/** The logo artwork carries a wide margin above and below the wordmark. The
 *  box is shorter than the image and crops that margin, so the header is
 *  thinner while the wordmark keeps its size. */
export const Link = styled(RouterLink)({
  display: 'flex',
  alignItems: 'center',
  width: '10rem',
  height: '3.3333rem',
  overflow: 'hidden',
});

const LogoImage = () => {
  const theme = useTheme<any>();
  const persona = usePersona();
  const shell = useAgencyShell();

  // The dark header is the dashboard header, however the agency came to have it.
  if (
    shell.header === 'dashboard' &&
    persona.isAgency &&
    theme.palette.mode === 'dark'
  ) {
    return <img src="images/Cowbell_Logo_white.svg" alt="cowbell-logo" />;
  }

  return <img src="logos/CowbellLogo.svg" alt="cowbell-logo" />;
};
